import PropTypes from 'prop-types';
import React from 'react';
import Button, { MODAL_FOOTER } from 'app/components/forms/Button';
import { createStyles } from 'app/utils/css';
import { refType } from 'app/utils/propTypes';

export default function ModalFooterButton({ onClick = () => {}, children, buttonRef = undefined }) {
  return (
    <Styles>{css =>
      <span className={css('modalFooterButton')}>
        <Button onClick={onClick} variant={MODAL_FOOTER} buttonRef={buttonRef}>
          {children}
        </Button>
      </span>
    }</Styles>
  );
}

ModalFooterButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  buttonRef: refType,
};

const Styles = createStyles({
  modalFooterButton: {
    marginLeft: '1em',
  },
});
